<template>
  <div class="tk-loading">
    <tk-cover
      center
      :class="{ 'loading-mobile': device === 'mobile' }"
      color="transparent"
      :hideOnClick="false"
      :show.sync="complete"
    >
      <tk-loading :color="'rgba(67, 67, 159, 1)'"> </tk-loading>
    </tk-cover>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .tk-loading {
    height: 100%;
    background: #ffffff;
    .loading-mobile {
      ::v-deep .tk-cover {
        top: 45px;
        margin: 0 auto;
      }
    }
  }
</style>
